var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.756,
    height: 14.756,
    viewBox: "0 0 14.756 14.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.366,1.39A4.753,4.753,0,0,0,5.483,6.216L.128,11.572A.432.432,0,0,0,0,11.877v2.446a.432.432,0,0,0,.432.432H2.879a.432.432,0,0,0,.306-.127l.611-.612a.432.432,0,0,0,.124-.355L3.844,13l.91-.086a.432.432,0,0,0,.39-.39l.086-.91.657.076a.425.425,0,0,0,.337-.106.433.433,0,0,0,.145-.323v-.8h.79a.432.432,0,0,0,.306-.127L8.573,9.24a4.682,4.682,0,0,0,4.793-1.125A4.761,4.761,0,0,0,13.366,1.39ZM12.143,4.447a1.3,1.3,0,1,1,0-1.834A1.3,1.3,0,0,1,12.143,4.447Z",
    transform: "translate(-0.001 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.0ee83c94e944337b9a9c7b672949e020.svg";
export { ForwardRef as ReactComponent };